<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card class="mb-3">
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="6" md="9">
              <v-btn
                class="white black--text d-print-none"
                small
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("btnPrint") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-md-none">
              <div class="text-right">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('labelSearch')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          :items-per-page="-1"
          :hide-default-footer="true"
          :mobile-breakpoint="breakpoint"
          sort-by="data_lancamento"
          :sort-desc="true"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id_lancamento="{ item }">
            <v-btn @click="$copy(item.id_lancamento)" x-small>{{
              item.id_lancamento
            }}</v-btn>
          </template>

          <template v-slot:item.nome_agente="{ item }">
            <a
              @click="
                $profile.showProfileDrawer(
                  item.id_agent,
                  'regionalManager/agents/getAgent'
                )
              "
            >
              <v-icon color="blue" x-small>mdi-account</v-icon>
              {{ item.nome_agente }}
            </a>
          </template>

          <template v-slot:item.nome_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_local,
                  'regionalManager/locals/getLocal'
                )
              "
            >
              <v-icon color="green" x-small>mdi-account</v-icon>
              {{ item.nome_local }}
            </a>
          </template>

          <template v-slot:item.data_lancamento="{ item }">
            {{ item.data_lancamento }}
          </template>

          <template v-slot:item.valor="{ item }">
            <div :class="item.valor <= 0 ? 'red--text' : 'green--text'">
              {{ item.valor }}
            </div>
          </template>
        </v-data-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="launch != ''">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">{{ $t("periodSummary") }}
                <div class="caption"> {{$store.state.rangeUI}}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>{{ $t("releasesLabel") }}</td>
                      <td class="text-right">{{ launch }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t("releasesPaid") }}</td>
                      <td :class="getColor(received)" class="text-right">
                        {{ received }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("releaseReceived") }}</td>
                      <td :class="getColor(paid)" class="text-right">
                        {{ paid }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("totalLabel") }}</td>
                      <td :class="getColor(total)" class="text-right">
                        {{ total }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "regional-manager-financial-collection-entry",
  components: {
    HeaderPrint,
  },
  data: () => ({
    items: [],
    search: "",
    breakpoint: "xs",
    launch: 0,
    paid: 0,
    received: 0,
    total: 0,
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_collector() {
      return this.$store.state.filters.autocompleteCollectors.id;
    },
    selectFinancialCategoryAgent() {
      return this.$store.state.filters.selectFinancialCategoryAgent.category;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        { text: this.$t("idLabel"), value: "id_lancamento" },
        { text: this.$t("headersAgentName"), value: "nome_agente" },
        { text: this.$t("localManagerName"), value: "nome_local" },
        { text: this.$t("date"), value: "data_lancamento", align: " caption" },
        { text: this.$t("releasedBy"), value: "responsavel_nome" },
        // { text: "Login", value: "responsavel_login" },
        { text: this.$t("valueLabel"), value: "valor" },
      ];
    },
  },

  watch: {
    saveFilters(val) {
      val && this.requestApi();
    },
  },
  methods: {
    resetPage() {
      this.search = "";
      this.some = {};
    },

    async requestApi() {
      this.resetPage();
      const body = {
        ...this.rangeDate,
        id_arrecadador: this.id_collector,
        id_local: this.id_local,
        categoria: this.selectFinancialCategoryAgent,
      };

      const request = await this.$request.post(
        "/regionalManager/financial/historicDeals",
        body
      );

      if (request.length == 0) {
        this.items = [];
        return;
      }

      this.items = request.dados;
      // handle date
      this.items.forEach((item) => {
        item.data_lancamento = new Date(
          item.data_lancamento.replace(" ", "T")
        ).toLocaleString();
      });
      this.resume(this.items);
    },

    setData(data) {
      this.resetPage();
      this.apuration = data;
    },

    resume(items) {
      this.resetPage();
      let launch = items.length;
      let paid = 0;
      let received = 0;
      let total = 0;

      items.forEach((item) => {
        if (item.categoria == 14) {
          paid = paid + Number(item.valor);
        }
        if (item.categoria == 15) {
          received = received + Number(item.valor);
        }
        total = total + Number(item.valor);
      });

      this.launch = launch;
      this.paid = paid.toFixed(2);
      this.received = received.toFixed(2);
      this.total = total.toFixed(2);
    },

    getColor(value) {
      if (value == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
  },
  // filters: {
  //   dateFormat: function (val) {
  //     var date = new Date(val).toLocaleString();
  //     return date;
  //   },
  // },
};
</script>
